// Typed references for the circle-internal practical-update surface.

import type { FunctionReturnType } from "convex/server";

import { api } from "../../../../convex/_generated/api";
import type { Id } from "../../../../convex/_generated/dataModel";

export const practicalUpdateQueries = {
  forNeed: api.domain.practicalUpdates.listForNeed,
  history: api.domain.practicalUpdates.history,
  forPrint: api.domain.practicalUpdates.listForPrint,
} as const;

export const practicalUpdateMutations = {
  createSelf: api.domain.practicalUpdates.createSelf,
  updateSelf: api.domain.practicalUpdates.updateSelf,
  updateProxy: api.domain.practicalUpdates.updateProxy,
  redactSelf: api.domain.practicalUpdates.redactSelf,
  redactProxy: api.domain.practicalUpdates.redactProxy,
} as const;

export type PracticalUpdatesForNeed = FunctionReturnType<typeof practicalUpdateQueries.forNeed>;
export type PracticalUpdateView = PracticalUpdatesForNeed["updates"][number];
export type PracticalUpdateHistory = FunctionReturnType<typeof practicalUpdateQueries.history>;
export type PracticalUpdatesForPrint = FunctionReturnType<typeof practicalUpdateQueries.forPrint>;

export function practicalUpdateDocumentId(value: string): Id<"practicalUpdates"> {
  return value as Id<"practicalUpdates">;
}

export function practicalUpdateNeedDocumentId(value: string): Id<"supportNeeds"> {
  return value as Id<"supportNeeds">;
}
